var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "SvgjsSvg1234",
    width: 18,
    height: 18,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnssvgjs: "http://svgjs.com/svgjs",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "SvgjsDefs1235"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SvgjsG1236"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: 18,
    height: 18,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "current",
    d: "M23.5 21H23v-9.5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0-.5.5V21h-2V1.5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0-.5.5V21H7V6.5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0-.5.5V21H.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h23a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5Z",
    "data-name": "Bar Chart 2",
    className: "color303c42 svgShape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartIcon);
export default __webpack_public_path__ + "static/media/chart-icon.15506408f590a6e334a24949d8d83d49.svg";
export { ForwardRef as ReactComponent };